module.exports = {"facebook":"#365397","twitter":"#00a9f1","linkedin":"#006db3","apple":"#737373","google":"#4285f4","google-plus":"#e0452c","youtube":"#ff3333","vimeo":"#48b6ed","pinterest":"#ce1a19","yelp":"#c30f00","dribbble":"#ed4584","amazon":"#ff9700","skype":"#00acf4","instagram":"#396d9a","dropbox":"#0d84de","flickr":"#ea0066","github":"#2f2f2f","tumblr":"#304c68","foursquare":"#207dc5"}


//////////////////
// WEBPACK FOOTER
// ./src/json/social-media-colors.json
// module id = 2205
// module chunks = 0